import { render, staticRenderFns } from "./IndexManager.vue?vue&type=template&id=2f22264c&scoped=true"
import script from "./IndexManager.vue?vue&type=script&lang=js"
export * from "./IndexManager.vue?vue&type=script&lang=js"
import style0 from "./IndexManager.vue?vue&type=style&index=0&id=2f22264c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f22264c",
  null
  
)

export default component.exports